export const escapeQuotes = (key, val) => {
  if (typeof val !== 'string') {
    return val;
  }
  return val.replace(/'/g, '&apos;');
};
